export default "__VITE_ASSET__A8G8cllJ__"